module.exports = __webpack_public_path__ + "static/media/bg2.f1e009d4.jpg";